__turbopack_context__.v({
  "benefitCard": "pky0eG_benefitCard",
  "benefitLabel": "pky0eG_benefitLabel",
  "benefitsGrid": "pky0eG_benefitsGrid",
  "cardLink": "pky0eG_cardLink",
  "ctaRow": "pky0eG_ctaRow",
  "description": "pky0eG_description",
  "engagementDetail": "pky0eG_engagementDetail",
  "engagementDuration": "pky0eG_engagementDuration",
  "engagementHeader": "pky0eG_engagementHeader",
  "intro": "pky0eG_intro",
  "layout": "pky0eG_layout",
  "title": "pky0eG_title",
});
